import { Injectable } from '@angular/core';

import { MessagesService }       from '../messages/messages.service';
import { ProductModel }          from './models/product';
import { VehicleVisualsFactory } from '../../app/vehicle-visuals/vehicle-visuals.service';

@Injectable()
export class ProductIntegrationsService {
  private product : ProductModel;

  constructor (
    private messagesService      : MessagesService,
    private vehicleVisualsFactory : VehicleVisualsFactory
  ) {}

  init (options: { product: ProductModel }) {
    this.product = options.product;
  }

  attachVehicleVisual () {
    if (!this.vehicleVisualsFactory) return;

    const vv = this.vehicleVisualsFactory.create();

    vv.attachToProduct().then(data => {
      this.product.vehicle_visuals_name = data.title || data.en_AU;
      return vv.getInteractiveUrl(data);
    }).then(data => {
      this.product.vehicle_visuals_url = data.url;
    }).catch(err => {
      if (!this.product.vehicle_visuals_url) this.product.vehicle_visuals_name = null;
      this.messagesService.error(err);
    });
  }

  clearVehicleVisual () {
    this.product.vehicle_visuals_name = null;
    this.product.vehicle_visuals_url  = null;
  }

  viewVehicleVisual () {
    window.open(this.product.vehicle_visuals_url, '_blank');
  }
}
